import { api } from 'api';
import { API_TAGS } from 'api/api.constant';

export const { useReadPageAclQuery } = api.injectEndpoints({
  endpoints: (builder) => ({
    readPageAcl: builder.query<unknown, string>({
      query: (pageUrl) => ({
        url: `${pageUrl}/acl`,
        method: 'get',
      }),
      providesTags: (_result, _error, pageUrl) => [API_TAGS.acl(pageUrl)],
    }),
  }),
});
